export const isNftyDisabledLoanProgram = (loanProgramCode: string): boolean => {
  return loanProgramCode?.toLowerCase()?.startsWith('flex heloc') || loanProgramCode?.toLowerCase()?.startsWith('brokered - nftyhel');
};
